// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__6vdKv","loader":"Loader_loader__ChRMX","shadow324":"Loader_shadow324__b3Xir","jump7456":"Loader_jump7456__g1Enf"};